export default [
  {
    "slug": "mp4",
    "group": "video",
    "ext": "mp4",
    "name": "mp4",
    "description": "MP4",
    "mime_type": "video/h264",
    "uploadable": false,
    "bin": true
  },
  {
    "slug": "mpeg_video",
    "group": "video",
    "ext": "mpg",
    "name": "mpeg video",
    "description": "MPEG-2 video file",
    "mime_type": "video/mpeg",
    "uploadable": false,
    "bin": true
  },
  {
    "slug": "mpeg_program",
    "group": "video",
    "ext": "ps",
    "name": "mpeg program stream",
    "description": "MPEG-2 program stream",
    "mime_type": "video/mp2p",
    "uploadable": false,
    "bin": true
  },
  {
    "slug": "mpeg_transport",
    "group": "video",
    "ext": "ts",
    "name": "mpeg transport stream",
    "description": "MPEG-2 transport stream",
    "mime_type": "video/mp2t",
    "uploadable": false,
    "bin": true
  },
  {
    "slug": "m4v",
    "group": "video",
    "ext": "m4v",
    "name": "mpeg 4",
    "description": "mpeg 4 video",
    "mime_type": "video/mp4",
    "uploadable": false,
    "bin": true
  },
  {
    "slug": "m4a",
    "group": "audio",
    "ext": "m4a",
    "name": "mpeg 4 audio",
    "description": "mpeg 4 audio",
    "mime_type": "audio/mp4",
    "uploadable": false,
    "bin": true
  },
  {
    "slug": "mp3",
    "group": "audio",
    "ext": "mp3",
    "name": "mpeg audio",
    "description": "mpeg audio",
    "mime_type": "audio/mpeg3",
    "uploadable": false,
    "bin": true
  }
  // mp3
]
